import * as React from 'react';

export const LocationContext = React.createContext<Location | null>(null);
